import { Stack, Tooltip, IconButton } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AccountMenu from '../../accountMenu/AccountMenu';
import UserNotifications from '../../notifications/UserNotifications';
import NavbarDropdowns from './NavbarDropdowns';
import { tokens } from '../../../mui-theme';
import { useUser } from '../../../context/UserContext';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { useAccess } from '../../../hooks/useAccess';

const logo = '/gainss-logo.png';
const secLogo = '/new-logo.png';

const NAV_HEIGHT = 64;

const iconButtonSx = (isActive = false) => ({
  color: isActive ? tokens.colors.primary[500] : tokens.colors.neutral[500],
  borderRadius: `${tokens.radius.sm}px`,
  p: '7px',
  transition: 'background 0.15s, color 0.15s',
  backgroundColor: isActive ? `${tokens.colors.primary[50]}` : 'transparent',
  '&:hover': {
    backgroundColor: tokens.colors.primary[50],
    color: tokens.colors.primary[500],
  },
});

function NewNavbar() {
  const { currentUser } = useUser();
  const { canAccess } = useAccess();
  const isTestProDomain = window.location.hostname === 'testpro.gainss.ai';
  const navigate = useNavigate();
  const isSuperAdmin = currentUser?.role === 'super-admin';

  return (
    <AppBar
      sx={{
        zIndex: 1201,
        backgroundColor: tokens.colors.neutral[100],
        boxShadow: 'none',
        borderBottom: `1px solid ${tokens.colors.neutral[200]}`,
        height: NAV_HEIGHT,
      }}>
      <Box sx={{ px: 3 }}>
        <Toolbar
          disableGutters
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            minHeight: `${NAV_HEIGHT}px !important`,
            height: `${NAV_HEIGHT}px`,
          }}>
          {/* Left: Logo + Nav */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Link to="/dashboard" style={{ display: 'flex', alignItems: 'center' }}>
              <img src={logo} width="115" alt="GAINSS" />
            </Link>
            {!isSuperAdmin && <NavbarDropdowns />}
          </Box>

          {/* Right: Actions */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              {isTestProDomain && (
                <Box>
                  <img src={secLogo} width="160" alt="TestPro" />
                </Box>
              )}

              {!isSuperAdmin && (
                <UserNotifications navHeight={NAV_HEIGHT} iconButtonSx={iconButtonSx} />
              )}

              {!isSuperAdmin && canAccess('ManageOrgSettings') && (
                <Tooltip title="Settings" arrow>
                  <IconButton
                    disableRipple
                    onClick={() => navigate('/settings')}
                    aria-label="Settings"
                    sx={iconButtonSx()}>
                    <SettingsOutlinedIcon sx={{ fontSize: 20 }} />
                  </IconButton>
                </Tooltip>
              )}

              <AccountMenu />
            </Stack>
          </Box>
        </Toolbar>
      </Box>
    </AppBar>
  );
}

export default NewNavbar;